/*eslint new-cap:0 */

import _ from 'underscore';
import 'backbone';
import config from '@bingads-webui-component-legacy/config/index';
import KeywordsView from '@bingads-webui-campaign-legacy/crud-keywords/view/create';
import { adGroupTypeEnum } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';

const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);

export function decorate(view) {
  return view.extend({
    initialize(options = {}) {
      const self = this;

      _.bind(view.prototype.initialize, this, options)();
      self.subView = new KeywordsView(self.options);
      self.subView.on({
        'seedKeywordsEntered': (seedKeywords) => {
          if (_.isArray(seedKeywords) && seedKeywords.length > 0) {
            self.trigger('seedKeywordsEntered', seedKeywords);
          }
        },
        'keywords:selected': () => {
          if (_.isFunction(self.selectThisAdGroup)) {
            self.selectThisAdGroup();
          }
        },
      });


      if (isDSAMixedModeCampaignEnabled) {
        this.ko_model.AdGroupType(adGroupTypeEnum.SearchStandard);
      }
    },

    addSuggestion(addedKeywords, name, suggestedAvgCpc, sourceReqId) {
      // Use the suggested ad group's name, unless the user already renamed this ad group
      if (_.isString(name)) {
        if (_.isEmpty(this.ko_model.Name())) {//eslint-disable-line
          this.ko_model.Name(name);//eslint-disable-line
          this.ko_model.suggestedAvgCpc(suggestedAvgCpc);

          this.hasChanges = true;
        }
      }

      this.subView.addSuggestion(addedKeywords, sourceReqId);
    },

    getChanges() {
      if (this.hasChanges || this.subView.hasChanges) {
        const serializedAdGroup = this.ko_model.toObject();
        const adGroupId = _.isNaN(serializedAdGroup.Id) || serializedAdGroup.Id < 1 ? null : serializedAdGroup.Id;

        const keywords = this.subView.getChangedKeywords({
          Id: adGroupId,
          Name: this.ko_model.Name(),//eslint-disable-line
        });

        serializedAdGroup.Keywords = keywords;
        serializedAdGroup['Client Id'] = `${this.ko_model.options.index}`;

        if (_.isNull(adGroupId)) {
          const keys = ['Client Id', 'Name', 'Campaign', 'Language', 'Keywords', 'PricingModel', 'Medium'];

          if (isDSAMixedModeCampaignEnabled) {
            keys.push('AdGroupType');
          }

          return _.pick(serializedAdGroup, keys);
        } else {
          const result = _.pick(serializedAdGroup, ['Client Id', 'Id', 'Name', 'Campaign', 'Keywords']);

          if (result.Keywords.length === 0) {
            if (this.hasChanges) {
              delete result.Keywords;
            } else {
              this.subView.hasChanges = false;
              return null;
            }
          }
          return result;
        }
      }
      return null;
    },

    getContextObject() {
      const adGroupsStored = this.options && this.options.context && this.options.context.get('AdGroups');
      const currentId = this.ko_model.Id();
      const currentAdGroup = _.chain(adGroupsStored).where({ Id: currentId }).first().value();

      let object = {
        Id: currentId,
        Name: this.ko_model.Name(),
        Keywords: this.subView.getContextObjects(),
        suggestedAvgCpc: this.ko_model.suggestedAvgCpc(),
      };

      if (currentAdGroup) {
        object.Bid = _.result(currentAdGroup, 'Bid');
      }

      if (isDSAMixedModeCampaignEnabled) {
        object.AdGroupType = adGroupTypeEnum.SearchStandard;
      }

      return object;
    },

    updateViewModels(data) {
      // BackFill adgroup's Id since it is saved
      _.bind(view.prototype.updateViewModels, this, data)();
      _.each(data.Keywords, (keyword) => {
        keyword.AdGroup = { Id: data.Id };
        keyword.Campaign = { Id: data.Campaign.Id };
      });

      if (data.Keywords) {
        //BackFill keywords' Ids
        const keywordObjects = this.subView.updateViewModels({
          keywords: data.Keywords,
          campaignId: data.Campaign.Id,
          adGroupId: data.Id,
        });

        this.ko_model.Keywords(keywordObjects);//eslint-disable-line
      }
    },

    updateViewModelsOnError(response) {
      if (response && response.errors && !response.entity) {
        //Ajax error [400] - RowCountExceeded
        view.prototype.showErrors(response.errors);
        return;
      }

      // BackFill adgroup's Id if it was saved, or show adgroup's errors if it was failed
      _.bind(view.prototype.updateViewModelsOnError, this, response, 'Keywords')();

      if (_.isEmpty(response.entity.errors)) {
        // If adgroup was saved, then some keywords may be failed to be saved
        const entity = response.entity;

        // If we tried to make keyword changes, we need to check if any succeeded and update the keyword viewmodels. Otherwise, we're done.
        if (entity.Keywords && entity.Keywords.length > 0) {
          _.each(entity.Keywords, (keyword) => {
            keyword.AdGroup = { Id: entity.Id };
            keyword.Campaign = { Id: entity.Campaign.Id };
          });

          //the second param indicates whether or not check if the keyword is saved (according to Id)
          const keywordObjects = this.subView.updateViewModels({
            keywords: entity.Keywords,
            hasErrors: true,
          });

          this.ko_model.Keywords(keywordObjects);//eslint-disable-line
        }
      } else {
        this.subView.clearErrors();
      }
    },
  });
}
